import type { IncludedSections } from '@/lib/api'
import { MapPin, X } from 'lucide-react'

export function SectionSelector({ floors, includedSections, onToggleFloor, onToggleArea, onClose }: {
  floors: Record<string, unknown>[]; includedSections: IncludedSections
  onToggleFloor: (floorId: string) => void; onToggleArea: (areaId: string) => void; onClose: () => void
}) {
  const includedFloors = includedSections.floors || []
  const includedAreas = includedSections.areas || []

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative bg-white rounded-t-2xl sm:rounded-2xl w-full sm:max-w-md max-h-[70vh] overflow-hidden border border-slate-200 shadow-2xl">
        <div className="flex items-center justify-between p-4 border-b border-slate-200">
          <h3 className="font-bold text-slate-800">Report Sections</h3>
          <button onClick={onClose} className="p-1.5 rounded-lg hover:bg-slate-100"><X className="w-4 h-4" /></button>
        </div>
        <div className="overflow-y-auto p-4 space-y-1 max-h-[50vh]">
          {floors.map(floor => {
            const floorId = floor.id as string
            const areas = (floor.areas || []) as Record<string, unknown>[]
            const floorIncluded = includedFloors.length === 0 || includedFloors.includes(floorId)
            return (
              <div key={floorId}>
                <label className="flex items-center gap-2 py-2 px-2 rounded-lg hover:bg-slate-50 cursor-pointer">
                  <input type="checkbox" checked={floorIncluded} onChange={() => onToggleFloor(floorId)} className="rounded border-slate-300 text-blue-600 w-4 h-4" />
                  <MapPin className="w-3.5 h-3.5 text-slate-400" />
                  <span className="text-sm font-semibold text-slate-800">{floor.floor_name as string}</span>
                </label>
                {areas.map(area => {
                  const areaId = area.id as string
                  const areaIncluded = floorIncluded && (includedAreas.length === 0 || includedAreas.includes(areaId))
                  return (
                    <label key={areaId} className="flex items-center gap-2 py-1.5 px-2 pl-8 rounded-lg hover:bg-slate-50 cursor-pointer">
                      <input type="checkbox" checked={areaIncluded} onChange={() => onToggleArea(areaId)} disabled={!floorIncluded} className="rounded border-slate-300 text-blue-600 w-3.5 h-3.5" />
                      <span className="text-xs text-slate-700">{area.area_name as string}</span>
                      <span className="text-[10px] text-slate-400">({area.area_code as string})</span>
                    </label>
                  )
                })}
              </div>
            )
          })}
        </div>
        <div className="p-4 border-t border-slate-200">
          <button onClick={onClose} className="w-full py-2 rounded-lg bg-blue-600 text-white text-sm font-semibold hover:bg-blue-700 transition-colors">Done</button>
        </div>
      </div>
    </div>
  )
}
